<script setup>
let titlePicture = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/factoryDisplay_1.jpg"
let equip_1 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/factoryEquip_1.png"
let factoryEquip_3 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/factoryEquip_3.png"
let factoryEquip_4 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/factoryEquip_4.png"
import contentTemplate from '@/components/contentTemplate.vue'
import down from "@/assets/img/down.png"

const pictures = [{
  "img_url": factoryEquip_3
}, {
  "img_url": factoryEquip_4
}, {
  "img_url": factoryEquip_3
}, {
  "img_url": factoryEquip_4
}, {
  "img_url": factoryEquip_3
}, {
  "img_url": factoryEquip_4
}
]
const importEquip = {
  "img_url": equip_1,
  "title": "高精度齿轮加工设备",
  "desc": "高精度齿轮加工技术将有效提高齿轮的精度和质量，降低齿轮的噪音和振动，提升齿轮的传动效率。这一系列技术的研发成功，将为我国的航空航天、汽车制造、机器人等高端装备制造领城提供强有力的支撑。",

}
</script>

<template>
  <div>
    <div class="first-picture-font gothamBold">
      <div style="font-weight: lighter">
        EQUIPMENT & ENVIRONMENT DISPLAY
      </div>
      <div class="puHuiTi-Medium" style="font-size: 1.5rem;font-weight: lighter">
        环境和设备信息
      </div>

      <el-image
          style="height: 2.5rem;padding-top: 0.8rem;  animation: smooth-bounce 2s infinite; /* 匀速跳动动画 */"
          :src="down" fit="cover"/>
    </div>
    <div style="background-color: rgb(243.9, 244.2, 244.8);">
      <!--    标题图片-->
      <el-image
          style="width: 100%;height: 23rem"
          :src="titlePicture"
          fit="cover"
      />

      <contentTemplate :pictures="pictures" :importEquip="importEquip">
      </contentTemplate>

    </div>
  </div>
</template>

<style scoped>
.factory-tab > /deep/ .el-tabs__header {
  background-color: white !important;
  height: 3rem;
}

.factory-tab .el-tabs__item {
  margin-left: 1.2rem; /* 或者使用padding-left */
}

/deep/ div.el-tabs.el-tabs--top.factory-tab > div.el-tabs__header.is-top > div > div > div > div.el-tabs__active-bar.is-top {
  background-color: #003795; /* 红色激活条 */
}

/deep/ #tab-factoryEnvironment {
  margin-left: 6rem;
}
</style>